export default class CommandStatus {
  static get Ok () { return 0 }
  static get Run () { return 1 }
  static get Error () { return 2 }
  static get NotFound () { return 3 }
  static get NotRun () { return 4 }
}
